<template>
  <div class="loader-container" v-if="isLoading">
    <svg class="spinner" viewBox="0 0 50 50">
      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"/>
    </svg>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useLoadingStore } from '@/stores/loading';

const store = useLoadingStore()
const isLoading = computed(() => store.isLoading)
</script>

<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* 전체 화면 중앙 */
  background: #f9f9f9;
}

.spinner {
  animation: rotate 1.5s linear infinite;
  width: 80px;
  height: 80px;
}

.path {
  stroke: #3d91d9;
  stroke-linecap: round;
  stroke-dasharray: 90, 150; /* 선 길이, 빈 공간 */
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>